export const mobileMaxWidth = '(max-width: 800px)';
